import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
`;

// Full size when the window is tall enough; on shorter windows it shrinks so
// the message and button stay on screen. A page sets
// --tasks-empty-reserve to the height everything else takes up, and can
// lower the --tasks-empty-min floor where space is tight.
export const Illustration = styled.img`
  width: auto;
  height: clamp(
    var(--tasks-empty-min, 120px),
    calc(100vh - var(--tasks-empty-reserve, 497px)),
    301px
  );
`;

export const Message = styled.p`
  margin: 0;
  color: var(--white);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xxl);
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.24px;
  text-align: center;
`;

export const CreateTaskButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 16px 8px 7px;
  border: none;
  border-radius: 32px;
  background-color: var(--white);
  color: var(--light-mode-purple);
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-l);
  font-weight: 500;
  line-height: 24px;
  cursor: pointer;

  &:hover {
    background-color: var(--blue-chalk);
  }

  &:focus-visible {
    outline: 2px solid var(--white);
    outline-offset: 2px;
  }
`;
